import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DetailedService from "../utils/ServicesDetailed/DetailedService";
import BankingKiosk from "../utils/ServicesDetailed/BankingKiosk";
import style from "./ServicesDisplay.module.css";


import recharge from "../utils/images/recharge.png";


import AEPS from "../utils/ServicesDetailed/AEPS";
import DMT from "../utils/ServicesDetailed/DMT";
import PanCard from "../utils/ServicesDetailed/PanCard";
import MicroAtm from "../utils/ServicesDetailed/MicroAtm";
import Recharges from "../utils/ServicesDetailed/Recharges";
import boxinsurance from "../utils/images/ServiceDetailImg/insurance.png";
import BillPayment from "../utils/ServicesDetailed/BillPayment";

const ServiceDisplay = () => {
  const [BankingKiosks, setBankingKiosks] = useState(false);
  const [isAEPS, setisAEPS] = useState(false);
  const [isDMT, setIsDMT] = useState(false);
  const [isPan, setIsPan] = useState(false);
  const [isRecharge, setisRecharge] = useState(false);
  const [isMicroATM, setIsMicroATM] = useState(false);
  const [isBillPayment, setIsBillPayment] = useState(false);
  const [isBoxInsurance, setIsBoxInsurance] = useState(false);

  const params = useParams();
  

  useEffect(() => {
    if (
      params.id === "banking-kiosk-facility,-bc-enrollment-process-and-benefits"
    ) {
      setBankingKiosks(true);
    }
    if (params.id === "company-offers-aadhaar-enabled-payment-system-(aeps)") {
      setisAEPS(true);
    }
    if (params.id === "domestic-money-transfer") {
      setIsDMT(true);
    }
    if (params.id === "pan-card-allotment") {
      setIsPan(true);
    }
    if (params.id === "micro-atm") {
      setIsMicroATM(true);
    }
    if (params.id === "recharges") {
      setisRecharge(true);
    }
    if (params.id === "bill-payment") {
      setIsBillPayment(true);
    }
    if (params.id === "box-insurance") {
      setIsBoxInsurance(true);
    }
  }, [params.id]);

  return (
    <section className={style.ServicesDetailsSection}>
      <div className={style.ServicesDetailsDiv}>
        {BankingKiosks ? <BankingKiosk /> : " "}
        {isAEPS ? (
          <AEPS
            
          />
        ) : (
          " "
        )}

        {isDMT ? (
          <DMT/>
        ) : (
          " "
        )}

        {isPan ? (
          <PanCard/>
        ) : (
          " "
        )}
        {isMicroATM ? (
         <MicroAtm/>
        ) : (
          " "
        )}
        {isRecharge ? (
          <Recharges/>
        ) : (
          " "
        )}

        {isBillPayment ? (
          <BillPayment/>
        ) : (
          " "
        )}
          {isBoxInsurance ? (
          <DetailedService
            heading="Box Insurance"
            body="All types of insurance through our portal easily by comparing the premiums from different insurance service providers."
            picture={boxinsurance}
          />
        ) : (
          " "
        )}
      </div>
    </section>
  );
};

export default ServiceDisplay;
